import { IEvent } from "@Interfaces";

export const getUpsellListingsForEventId = ({
    eventId,
    event,
}: {
    eventId: string;
    event: IEvent.IStore;
}): Array<IEvent.IUpsellOffering> => {
    return event?.upsellListings?.[eventId] || [];
};
